<!-- eslint-disable no-unused-vars -->
<template>
  <div>
    <banner ref="header"></banner>
    <cebianlan></cebianlan>
    <!-- 课程详情 -->
    <div class="details">
      <div class="container">
        <!-- 详情头部 -->
        <!-- <div class="details-header">{{ course.cateNameChain }}-> {{ course.name }}</div> -->
        <div class="details-header">个人中心 -> 1v1约课 ->{{ course.name }}</div>
        <!-- 视频部分 -->
        <div class="video">
          <div class="course-content-main">
            <div class="course-img" :style="{ backgroundImage: 'url(' + course.cover + ')' }" v-if="!VODData"></div>
            <div class="course-img" v-show="VODData">
              <SHPlayer
                  videoType="vod"
                  ref="mainVideo"
                  class="main-video"
                  playerType="tcPlayer"
                  :fans_id="fans_id"
                  @play="onPlayerPlay"
                  @pause="onPlayerPause"
                  @playSpeed="handlePlaySpeed"
                  @seeking="handleSeek"
                />
            </div>

            <div class="course-chapter" style="position: relative;">
              <div v-if="isThreeScreenCourse" style="height: 200px;">
                <div style="height: 200px; position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: #000;">
                  <SHPlayer
                  videoType="vod"
                  ref="cameraVideo"
                  class="main-video"
                  playerType="tcPlayer"
                  :fans_id="fans_id"
                  :speedValue="whiteBoardSpeed"
                  :hideControl="true"
                />
                </div>
              </div>
              <div :style='{"top":isThreeScreenCourse ? "200px":"0"}' style="overflow: auto;position: absolute; top: 200px; left: 0; right: 0; bottom: 0; background: #000;">
                <template>
                <div class="course-chapter-item" v-for="(innerItem,idx) in OneChapterList" :key="innerItem.id">
                    <div class="chapter-item-num">{{ idx + 1 }}</div>
                    <div class="chapter-item-content">
                      <div class="item-content-top">
                        <div class="chapter-review" v-if="innerItem.type == 3">回放</div>
                        <div class="chapter-review" style="background: #1872ed;" v-if="innerItem.type == 5">直播</div>
                        <div class="chapter-item-title">{{ innerItem.name }}</div>
                      </div>
                      <div class="item-content-bottom">
                        {{ innerItem.start_time }}
                      </div>
                      <template v-if="innerItem.videos.length">
                        <div class="chapter-review-item" v-for="deepItem in innerItem.videos" :key="deepItem.id" @click="liveAutha(innerItem.id, deepItem)" :class="deepItem.id === reviewActiveId ? 'review-active' : ''">
                          <i class="iconfont">&#xe7e9;</i>
                          <span class="review-item-name">{{ deepItem.name }}</span>
                          <span style="flex:1"></span>
                          <span class="review-item-time">{{ formateSeconds(deepItem.duration) }}</span>
                        </div>
                      </template>
                    </div>
                    <div v-if="innerItem.status === 2" @click="liveAuth(innerItem)" class="live">
                      <i class="iconfont live-status" v-if="innerItem.status === 2">&#xe6e1;</i>
                      <div class="enter-live">进入直播</div>
                    </div>
                    <div class="live-over" v-else-if="innerItem.status === 1">直播未开始</div>
                    <div class="live-over" v-else-if="innerItem.status === 3">直播已结束</div>
                  </div>
              </template>
              </div>
            </div>
          </div>
          <div class="video-consultation">
            <div class="video-consultation-left">
              <p>{{ course.name }}</p>
            </div>
          </div>
        </div>
      </div>
      <div style="width: 100%; height: 20px"></div>
      <div style="clear: both"></div>
    </div>
    <Login ref="loginH" @updateLoginState="changeLoginState" />
    <!-- 尾部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import banner from './banner'
import bottom from './bottom'
import cebianlan from './cebianlan'
import { mapState } from 'vuex'
import Login from './login'
import SHPlayer from 'shplayer';
export default {
  data() {
    return {
      OneChapterList:'',
      desc: '',
      class_id: 0,
      course: {},
      VODData: null,
      reviewActiveId: '',
      initHeight: 56,
      vodTime:null,
      playStatus:'',
      vodDom:null,
      fans_id:'',
      uid:'',
      fileId:'',
      wx_h5_url:"https://u.shanhuclass.cn",
      currentSectionId:'',
      currentVideoId:'',
      sectionVideoList:[],
      isThreeScreenCourse:false,
      whiteBoardSpeed:1
    }
  },

  beforeDestroy() {
    const body = document.querySelector('body')
    body.removeAttribute('style')
    clearInterval(this.vodTime)
    
  },
  created(){
    this.get1v1List()
  },
  mounted() {
    console.log('11122311',this.chapterList)
    this.$store.dispatch('getOrgID', this.$store.state.domain).then(()=>{
      this.uid = this.$store.state.user.org_id
      this.getCourseInfo()
      this.listClass()
      this.getMiniConfigAll()
    })
    this.fans_id = this.$store.state.user.fans_id 
  },
  components: {
    banner,
    bottom,
    cebianlan,
    Login,
    SHPlayer
  },
  computed: {
    // 获取商户id
    ...mapState(['org_id']),

    // 将秒转化为时分秒
    formateSeconds() {
      return function (endTime) {
        let secondTime = parseInt(endTime) // 将传入的秒的值转化为Number
        let min = 0 // 初始化分
        let h = 0 // 初始化小时
        let result = ''
        if (secondTime > 60) {
          // 如果秒数大于60，将秒数转换成整数
          min = parseInt(secondTime / 60) // 获取分钟，除以60取整数，得到整数分钟
          secondTime = parseInt(secondTime % 60) // 获取秒数，秒数取佘，得到整数秒数
          if (min > 60) {
            // 如果分钟大于60，将分钟转换成小时
            h = parseInt(min / 60) // 获取小时，获取分钟除以60，得到整数小时
            min = parseInt(min % 60) // 获取小时后取佘的分，获取分钟除以60取佘的分
          }
        }
        result = `${h.toString().padStart(2, '0')}:${min
          .toString()
          .padStart(2, '0')}:${secondTime.toString().padStart(2, '0')}`
        return result
      }
    },
  },
  methods: {
    //1v1章节列表
    get1v1List(){
      const data = {
        course_id:this.$route.query.id
      }
      this.$axios.post("stu/course/list1v1Chapters",data)
      .then((res) =>{
          if(res.data.code == 200){
            this.OneChapterList = res.data.data.list
            console.log(this.OneChapterList,'asdasdasdasdasdasdasda')
          }
      })
    },
    // 课程详情接口
    getCourseInfo() {
      const data = {
        org_id: this.org_id,
        course_id:this.$route.query.id,
      }
      this.$axios.post('/stu/course/getCourseInfo', data).then((res) => {
        if (res.data.code === 200) {
          res.data.data.desc = res.data.data.desc.replace(
            /<img /g,
            '<img style= "width:100%"'
          )
          this.course = res.data.data
        }
      })
    },
    onPlayerPlay() {
      this.playStatus = 2;
        if(this.isThreeScreenCourse) {
            this.$refs.cameraVideo.play();
            return;
        }
    },
    onPlayerPause() {
      this.playStatus = 3;
        if(this.isThreeScreenCourse) {
            this.$refs.cameraVideo.pause()
            return;
        }
    },
    handleSeek(val){
        if(this.isThreeScreenCourse) {
            this.$refs.cameraVideo.setCurrentTime(val, true);
        } 
    },
    handlePlaySpeed(val){
        if(this.isThreeScreenCourse) {
            this.whiteBoardSpeed = val;
        }
    },
    // 直播鉴权
    liveAuth(item) {
      console.log(item)
      const { status, id } = item
      const data = {
        course_id: this.$route.query.id,
        class_id: this.class_id,
        chapter_id: id,
      }

      if (status !== 2 && status !== 4) return
      this.$axios.post('/stu/course/liveAuth', data).then((res) => {
        if (res.data.code === 200) {
          if(item.type == 4){
             this.fakeLiveJump(item, res.data)
          }else{
            this.liveAddress(item, res.data)
          }
        
        } else if (res.data.code === 400) {
          this.$message({
            type: 'info',
            message: res.data.message,
          })
        } else {
          this.$message({
            type: 'info',
            message: '请登录后再试',
          })
          this.$refs.loginH.open()
        }
      })
    },
    resetData(){
      this.isThreeScreenCourse = false
    },
    // 录播鉴权
    liveAutha(id, item) {
      console.log('111111111111', item.id)
      this.resetData()
      const data = {
        // token: '2izQbyKJTrgwxI7pjSsd3Hw/V+4SuHjNSfP/qEzAj+Jq0RShGSspduksRsO7LrR7eG8vCzmbVJLDfJRXiHl8jGEBCjlLydDFTPrRe+psa0pIeju9RW275CrUmr8wskC3FuvyUdjIInmb8asX0wkk5dKnV1hOvmPcUYOILCvtyj3KKg+B2fGSBK1qX7rdB14s5M/N4pr9VQ+0i/o2rJw1CRlLHEJqDG5YG7GXCglriwyUEQ5VEeJx/1fdVax1ECy6xacDZ79ZZatzOuVKqWWbHJ0/ICs2ezG69rxTq8Clj84IkChp/lQhGvTc/ORdHZXjIXwds7BlY2ZUWnLh+T2z2UdGYcKLcT4Zx8m/qmKGv5m+j0PsoRa7H14OwcG67/Bv',
        course_id: this.$route.query.id,
        class_id: this.class_id,
        chapter_id: id,
        video_id: item.id,
      }
      this.$axios.post('/stu/course/videoAuth', data).then((res) => {
        if (res.data.code === 200) {
          localStorage.setItem('shipingID', item.id)
          this.reviewActiveId = item.id
          console.log('wwwwwwwww',this.reviewActiveId)
          const vodData = {
            mp4Url: res.data.data.video.mp4Url,
            isAutoPlay:true
          }
          this.VODData = vodData
          this.fileId = res.data.data.video.file_id
          this.startVodTime()
          this.handlePlayVideo(
              res.data.data.video,
              res.data.data.new_video,
              res.data.data.new_video_wb
            );
        } else if (res.data.code === 400) {
          this.$message({
            type: 'info',
            message: res.data.message,
          })
        } else {
          this.$message({
            type: 'info',
            message: '请登录后再试',
          })
          this.$refs.loginH.open()
        }
      })
    },
    
    // eslint-disable-next-line no-unused-vars
    handlePlayVideo(item, new_video, new_video_w){
      // eslint-disable-next-line no-unused-vars
      const { mp4Url,sMp4Url,file_id,appid,sign,s_appid,s_file_id,s_sign,original,s_original } = item;
      let options = {}
      let sOptions = {}
      if (original === 1) { //播URL
        options = {
          sources: [mp4Url],
          playType: 'url',
          // startTime: this.memoryPoints,
          autoplay: true,
        };
      }else { //播filedid
        options = {
            fileID: file_id,
            appID: appid,
            psign: sign,
            autoplay: true,
            playType: 'file_id',
            // startTime: this.memoryPoints,
        };
      }

      if (s_file_id || sMp4Url) { //有白板视频
                this.isThreeScreenCourse = true
                if (s_file_id) {
                    sOptions = {
                        fileID: s_file_id,
                        appID: s_appid,
                        psign: s_sign,
                        playType: 'file_id',
                        sources: [sMp4Url],
                        // startTime: this.memoryPoints,
                        autoplay: true,
                    }
                }else if (sMp4Url) {
                    sOptions = {
                        sources: [sMp4Url],
                        playType: 'url',
                        // startTime: this.memoryPoints,
                        autoplay: true,
                    }
                }
            }
     
      this.$nextTick(() => {
        if (this.isThreeScreenCourse) {
            this.$refs.cameraVideo.setPlayerParams(options);
            this.$refs.mainVideo.setPlayerParams(sOptions);
        }else {
            this.$refs.mainVideo.setPlayerParams(options);
        }
      });

    },
    fakeLiveJump(item1,item) {
      console.log('qq',this.wx_h5_url);
      const liveUrl = `${this.wx_h5_url}/f?ds_id=${item1.ds_id}&tid=${
        item1.room_id
      }&token=${
        item.data.liveToken
      }&other=1&shool_token=${localStorage.getItem('token')}`

      console.log("fakeLiveJump",liveUrl);

      location.href = liveUrl
    },
    // 查询直播地址
    liveAddress(item1, item) {
      if(item1.play_style == 4){
        location.href = `${this.wx_h5_url}/tcicMiddlePage/#/pc?classid=${item1.interact_id}&fans_id=${this.fans_id}&ds_id=${item1.ds_id}`
      }else{

        const liveUrl = `${this.wx_h5_url}?ds_id=${
          item1.ds_id
      }&token=${
        item.data.liveToken
      }&other=1&shool_token=${localStorage.getItem('token')}`
       
      console.log("liveAddress",liveUrl);

      location.href = liveUrl
      }
       
    },
    getMiniConfig(){
      this.$axios.get('https://tengface-live.oss-cn-beijing.aliyuncs.com/web/config/userConfig/'+ this.uid +'.json?a='+ new Date().valueOf())
              .then( (response) => {
                if (response.data) {
                    if (response.data.wx_h5_url) {
                        this.wx_h5_url = response.data.wx_h5_url
                    }
                }

              })
              .catch(function (error) {
                console.log(error);
              });
        },
         getMiniConfigAll(){
          this.$axios.get('https://shanhu-live-user-1317978474.cos.accelerate.myqcloud.com/web/config/miniConfig.json?a='+ new Date().valueOf())
              .then( (response) => {
                if (response.data) {
                  if (response.data.wx_h5_url) {
                    this.wx_h5_url = response.data.wx_h5_url
                  }
                }
                 this.getMiniConfig();
              })
              .catch(function (error) {
                console.log(error);
              });
        },
    // 改变登陆状态
    changeLoginState() {
      this.$refs.header.changeLoginState()
    },
    startVodTime () {
      clearInterval(this.vodTime)
      this.vodTime = setInterval(() => {
        if (this.playStatus == 2) {
          const progress = parseInt(this.vodDom.currentTime)
          const data ={
            file_id:this.fileId,
            fans_id:this.fans_id,
            uid:this.uid,
            progress
          }
          this.$liveUser.post("/app/index/videoHeart", data).then(res=>{
            console.log(res)
          })
        }
      }, 5000)
    }
  },
}
</script>

<style lang="scss" scoped>
/* 公共样式 */
* {
  padding: 0;
  margin: 0;
}

a {
  color: #434343;
  text-decoration: none;
  /* 取消下划线 */
}

li {
  list-style: none;
}
p {
  margin: 0;
  padding: 0;
}

body {
  background-color: #fff;
  /* 整个页面的颜色 */
  font-size: 14px;
}

input {
  border: 0;
  /* 所有的input边框为0 */
  outline: none;
  /* 去掉默认边框 */
  box-sizing: border-box;
  /* css3模型 border和padding 包含在盒子里 */
}

.container {
  margin: 0 auto;
  // padding-left: calc(100vw - 100%);
}

/* 课程详情部分开始 */
.details {
  background-color: #f5f6f7;
  padding-bottom: 30px;
  min-width: 972px;
}

.details-header {
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  color: #4d4d4d;
}

.details-header a {
  color: #545454;
}

.details-header span {
  color: #545454;
  padding: 0 14px;
}
.course-img {
  background-position: center;
  background-size: cover;
  min-width: 645px;
  min-height: 430px;
}

.video-population {
  height: 600px;
}

.video-playback {
  width: 900px;
  height: 600px;
  float: left;
  background-color: pink;
}

.video-details {
  width: 360px;
  height: 600px;
  float: left;
  background-color: #191a20;
  overflow-y: scroll;
}

.video-details ul li {
  height: 70px;
}

.video-details a {
  display: block;
  height: 70px;
  margin-bottom: 6px;
}

.video-details a .span02 {
  display: block;
  width: 21px;
  height: 28px;
  float: left;
  margin: 20px 17px 0 24px;
  text-align: center;
  color: #515151;
  font-size: 18px;
  font-weight: 500;
}

.video-details a div {
  float: left;
  margin-top: 20px;
}

.video-details a div p {
  font-size: 16px;
  color: #b7b7b7;
}

.video-details a div p span {
  display: block;
  float: left;
  width: 30px;
  height: 16px;
  background-color: #ff9d2d;
  color: #fff2e4;
  font-size: 12px;
  text-align: center;
  border-radius: 2px;
  margin-top: 2px;
  margin-right: 9px;
}

.video-details a div p:last-child {
  color: #515151;
  font-size: 12px;
  margin-top: 5px;
}

/* ????? */
.video-details a:hover p {
  color: #10a675;
}

.video-details a:hover .span02 {
  color: #10a675;
}

.video-details a:hover p:last-child {
  color: #10a675;
}

.video-details a:focus p {
  color: #10a675;
}

.video-details a:focus .span02 {
  color: #10a675;
}

.video-details a:focus p:last-child {
  color: #10a675;
}

.video-consultation {
  height: 90px;
  background-color: #222328;
}

.video-consultation-left {
  float: left;
  margin-left: 30px;
  // width: 900px;
  height: 90px;
}

.video-consultation-left p:first-child {
  padding-top: 20px;
  font-size: 24px;
  font-weight: 700;
  color: #b7b7b7;
  margin-bottom: 10px;
}

.video-consultation-left p:nth-child(2) {
  display: block;
  float: left;
  padding-right: 40px;
  color: #7e7e7f;
}

.video-consultation-left p img {
  padding-right: 10px;
}

.video-consultation-left p:last-child {
  display: block;
  float: left;
  color: #7e7e7f;
}

.video-consualtation-right {
  width: 300px;
  padding-right: 30px;
  padding-top: 17px;
  float: right;
  cursor: pointer;
}

.video-consualtation-right a {
  display: block;
  // width: 300px;
  height: 57px;
  background-color: #10a675;
  color: #ffffff;
  font-size: 22px;
  border-radius: 25px;
  line-height: 57px;
  text-align: center;
}

/* 信息部分 */
.information {
  margin-top: 20px;
}

.information-container {
  width: 810px;
  margin: 0 auto;
  margin-bottom: 20px;
}
/* 切换班级样式 */
.change-class {
  display: flex;
  padding: 10px 0;
  align-items: center;
}
.class-title {
  margin-right: 10px;
}
.el-select-dropdown__item {
  margin-left: 15px;
}
.information-left {
  // width: 870px;
  min-width: 972px;
  float: left;
  background-color: #ffffff;
  padding-bottom: 20px;
}

.information-left-header {
  border-bottom: 2px solid #e8eaec;
  line-height: 20px;
  font-size: 16px;
  display: flex;
}
.information-left-header .change-class {
  margin-left: auto;
}

.information-left-header-left {
  padding: 22px 0;
  font-size: 16px;
  color: #20242f;
  border-bottom: 1px solid #e8eaec;
  font-weight: 700;
  border: none;
}
.info-content {
  font-size: 14px;
}

.information-left-header-left a:nth-child(2) {
  margin: 0 60px;
}

.information-left-header-left a:nth-child(2) span {
  padding-bottom: 18px;
  border-bottom: 4px solid #10a675;
}

.information-left-header-right {
  float: right;
}

.information-left-header-right img {
  padding-right: 8px;
}
.course-content-main {
  display: flex;
}
@media screen and (max-width: 992px) {
  .course-chapter {
    max-height: 430px;
  }
}
.course-chapter {
  background: #191a20;
  flex: 1;
  overflow-y: auto;
  color: #b7b7b7;
  padding: 0 20px;
  box-sizing: border-box;
  .chapter-main {
    overflow: hidden;
    transition: all 0.5s;
    height: 56px;
  }
}
/* 滚动条样式 */
.course-chapter::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.course-chapter::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #535353;
}
.course-chapter::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}
.contentWx-cover {
  position: fixed;
  left: 0;
  right: 0;
  top: 64px;
  bottom: 0;
  background: #0c0d1094;
  z-index: 1000;
}
.contentWx-img {
  width: 400px;
  height: 500px;
  background: #ffffff;
  border-radius: 16px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 40px 0;
  z-index: 998;
}
.contentWx-img {
  width: 400px;
  height: 500px;
  background: #ffffff;
  border-radius: 16px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 40px 0;
}
.contentWx-img div:first-child {
  font-size: 24px;
}
.contentWx-img div:last-child {
  font-size: 20px;
}
.contentWx-cover img {
  width: 40%;
  margin: 30px 0;
}
.contentWx-img button {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 20px;
  right: 20px;
  // width: 35%;
  // height: 42px;
  border-radius: 29px;
  background: #10a675;
  color: #ffffff;
  border: none;
  cursor: pointer;
}

/* 目录信息 */
.information-left-catalogue {
  height: 1100px;
}

.information-left-catalogue .mulu {
  min-height: 90px;
  width: 810px;
  margin-top: 20px;
  background-color: #f9f9f9;
}

.information-left-catalogue div {
  display: block;
}

.information-left-catalogue div {
  float: left;
  margin-top: 20px;
}

.information-left-catalogue p {
  font-size: 16px;
  color: #20242f;
}

.information-left-catalogue .leixin {
  display: block;
  float: left;
  width: 30px;
  height: 16px;
  background-color: #10a675;
  color: #fff2e4;
  font-size: 12px;
  text-align: center;
  border-radius: 2px;
  margin-top: 2px;
  margin-right: 9px;
}

.span01 {
  display: block;
  width: 27px;
  height: 28px;
  float: left;
  margin: 16px 20px 0 20px;
  text-align: center;
  color: #10a675;
  font-size: 24px;
}

.information-left-catalogue p:last-child {
  color: #808695;
  font-size: 14px;
  margin-top: 20px;
}

.information-left-catalogue a {
  height: 30px;
  width: 90px;
  line-height: 30px;
  text-align: center;
  display: block;
  float: right;
  border: 1px solid #1872ed;
  border-radius: 25px;
  margin-top: 29px;
  margin-right: 20px;
}

/* 右边 */
.information-right {
  width: 360px;
  float: right;
  background-color: #ffffff;
}

.information-right01 {
  height: 84px;
  margin-top: 22px;
}

.information-right01 span {
  display: block;
  float: left;
  height: 64px;
  width: 55px;
  line-height: 64px;
  color: #ffffff;
  background-color: #10a675;
  padding-left: 9px;
  font-size: 15px;
  letter-spacing: 1px;
  font-weight: 700;
  border-radius: 10px;
}

.information-right01 div {
  float: left;
  padding-left: 12px;
}

.information-right01 div p:first-child {
  font-size: 20px;
  padding-top: 3px;
}

.information-right01 div p:last-child {
  color: #9a9fab;
  padding-top: 10px;
}

.information-right02 {
  height: 72px;
}

.information-right02 div {
  width: 93.3px;
  height: 72px;
  text-align: center;
  background-color: #f9f9f9;
  float: left;
}

.information-right02 div:nth-child(2) {
  margin: 0 10px;
}

.information-right02 div p {
  color: #9fa4af;
  padding: 15px 0;
}

.information-right03 {
  margin-top: 25px;
  margin-bottom: 20px;
}

.information-right03 p {
  text-indent: 2em;
  /* 首行缩进 */
  line-height: 150%;
}

.information-right03 p span {
  letter-spacing: 1px;
}

/* 课程详情部分结束 */
/* 合作与联系开始 */
.contact {
  height: 210px;
  background-color: #101115;
}

.contact-left {
  float: left;
}

.contact-left dt {
  color: #82858a;
  font-size: 20px;
  font-weight: 700;
  padding-top: 55px;
  padding-bottom: 12px;
  letter-spacing: 4px;
  /* 字间距为4px */
}

.contact-left dd {
  color: #65676c;
  font-size: 13px;
  padding-top: 20px;
}

.contact-right {
  float: right;
}

.contact-right img {
  padding-top: 46px;
  padding-bottom: 12px;
}

.contact-right p {
  color: #65676c;
}

.contact-middle {
  float: right;
  margin-right: 93px;
}

.contact-middle dd {
  color: #65676c;
  font-size: 13px;
  padding-top: 20px;
}

.contact-middle dd:first-child {
  padding-top: 52px;
}

.contact-middle dd:nth-child(2) {
  padding-top: 20px;
}

.contact-middle dd:last-child {
  padding-top: 14px;
}

.contact-middle dt {
  color: #82858a;
  font-size: 20px;
  padding-top: 23px;
}

/* 合作与联系结束 */
/* 尾部开始 */
.tail {
  height: 50px;
  line-height: 50px;
  background-color: #0c0d10;
}

.tail p {
  width: 100%;
  color: #65676c;
  font-size: 13px;
  margin: auto;
  text-align: center;
}
.chapter-title {
  height: 44px;
  width: 100%;
  margin-top: 12px;
  font-size: 16px;
  color: #e6e6e6;
  line-height: 44px;
  background: #2b2c35;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
  .chapter-text {
    display: block;
    width: 95%;
    max-width: 310px;
    padding-left: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .iconfont {
    position: absolute;
    right: 10px;
    transition: all 0.5s;
  }
}

.course-chapter-item {
  margin-top: 20px;
  padding: 0 16px 0 24px;
  display: flex;
  cursor: pointer;
}
.chapter-item-num {
  margin-right: 12px;
  font-size: 18px;
  color: #515151;
}
.chapter-item-content {
  flex: 1;
}
.item-content-top {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
.chapter-review {
  min-width: 30px;
  height: 16px;
  font-size: 12px;
  color: #ffffff;
  background: #ff9d2d;
  border-radius: 2px;
  text-align: center;
  margin-right: 8px;
}
.chapter-no-review {
  width: 30px;
  height: 16px;
  margin-right: 8px;
}
.chapter-item-title {
  font-size: 16px;
  color: #b7b7b7;
  font-weight: 700;
}
.item-content-bottom {
  font-size: 12px;
  color: #515151;
  margin-bottom: 10px;
}
.chapter-review-item {
  font-size: 14px;
  color: #b7b7b7;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  position: relative;
  .iconfont {
    margin-right: 6px;
    transform: translateY(1px);
  }
}
.review-active {
  color: #1872ed;
}
.chapter-review-item img {
  width: 14px;
  height: 14px;
  margin-right: 8px;
}
// .review-item-time {
//   position: absolute;
//   right: 0px;
// }
.live {
  display: flex;
}
.enter-live {
  font-size: 12px;
  width: 60px;
  height: 24px;
  background: #1872ed;
  color: #fefffe;
  line-height: 24px;
  text-align: center;
  border-radius: 16px;
  transform: translateY(3px);
  margin-left: 6px;
}
.live-status {
  color: #1872ed;
  transform: translateY(4px);
}
.live-over {
  color: #b7b7b7;
  font-size: 12px;
  transform: translateY(5px);
}
/* 尾部结束 */
</style>
